import Api from './Api';
import history from '../history';
import configData from "../config.json";

export default class AccedanApi extends Api{

    constructor(props){
	super(props);
	this.errorCallback = this.errorCallback.bind(this);
    	this.setBaseUrl(process.env.REACT_APP_API_BASE_URL || 'http://localhost:3002');
    }

    errorCallback(){

	history.push('/login');
    }

    getToken(){
        return localStorage.getItem("token");
    }

    login(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'login');
        this.commonPostApiCall(false, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    recoverPassword(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'recoverPassword');
        this.commonPostApiCall(false, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    changePassword(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'changePassword');
        this.commonPostApiCall(false, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    validateToken(callback){
        const configRoute = configData.routes.find(route => route.name === 'validateToken');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url, callback,this.errorCallback); 
    }

    getUser(userId, callback){
        const configRoute = configData.routes.find(route => route.name === 'getUser');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+userId, callback,this.errorCallback); 
    }

    updateUser(arrayParams, callback){
    	const userId = arrayParams._id;
        const configRoute = configData.routes.find(route => route.name === 'updateUser');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url+userId, callback,this.errorCallback); 
    }

    newUser(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'newUser');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getUsers(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getUsersByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getUsersForMe(arrayParams,callback){
        arrayParams.push({name:'byToken', value: '1'});
        this.getUsers(arrayParams, callback,this.errorCallback); 
    }

    deleteUser(userId, callback){
        const configRoute = configData.routes.find(route => route.name === 'deleteUser');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+userId, callback,this.errorCallback); 
    }

    newSigning(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'newSigning');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    newSigningByToken(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'newSigningByToken');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getSignings(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getSigningsByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    deleteSigning(signingId, callback){
        const configRoute = configData.routes.find(route => route.name === 'deleteSigning');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+signingId, callback,this.errorCallback); 
    }

    getSigning(signingId, callback){
        const configRoute = configData.routes.find(route => route.name === 'getSigning');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+signingId, callback,this.errorCallback); 
    }

    updateSigning(arrayParams, callback){
    	const signingId = arrayParams._id;
        const configRoute = configData.routes.find(route => route.name === 'updateSigning');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url+signingId, callback,this.errorCallback); 
    }

    downloadSignings(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'downloadSigningsByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback, true); 
    }

    checkRecoveryData(recoverId, callback){
        const configRoute = configData.routes.find(route => route.name === 'checkRecoveryData');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+recoverId, callback,this.errorCallback); 
    }

    newClient(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'newClient');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    newClientByToken(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'newClientByToken');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getClients(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getClientsByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    deleteClient(clientId, callback){
        const configRoute = configData.routes.find(route => route.name === 'deleteClient');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+clientId, callback,this.errorCallback); 
    }

    getClient(clientId, callback){
        const configRoute = configData.routes.find(route => route.name === 'getClient');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+clientId, callback,this.errorCallback); 
    }

    updateClient(arrayParams, callback){
    	const clientId = arrayParams._id;
        const configRoute = configData.routes.find(route => route.name === 'updateClient');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url+clientId, callback,this.errorCallback); 
    }

    downloadClients(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'downloadClientsByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback, true); 
    }

    newSchedule(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'newSchedule');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getSchedules(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getSchedulesByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    deleteSchedule(scheduleId, callback){
        const configRoute = configData.routes.find(route => route.name === 'deleteSchedule');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+scheduleId, callback,this.errorCallback); 
    }

    getSchedule(scheduleId, callback){
        const configRoute = configData.routes.find(route => route.name === 'getSchedule');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+scheduleId, callback,this.errorCallback); 
    }

    updateSchedule(arrayParams, callback){
    	const scheduleId = arrayParams._id;
        const configRoute = configData.routes.find(route => route.name === 'updateSchedule');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url+scheduleId, callback,this.errorCallback); 
    }

    uploadFile(formData,callback){
        const configRoute = configData.routes.find(route => route.name === 'uploadFile');
        //Los headers son distintos porque el mismo formData es quien determina los que debe llevar
        this.commonPostApiCall(true, configRoute.method, formData, configRoute.url, callback, this.errorCallback, null, {}); 
    }
    
    deleteFile(fileId, callback){
        const configRoute = configData.routes.find(route => route.name === 'deleteFile');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+fileId, callback,this.errorCallback); 
    }

    downloadFile(fileId, callback){
        const configRoute = configData.routes.find(route => route.name === 'downloadFile');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+fileId, callback,this.errorCallback, true); 
    }

    newArticle(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'newArticle');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    newArticleByToken(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'newArticleByToken');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getArticles(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getArticlesByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    deleteArticle(articleId, callback){
        const configRoute = configData.routes.find(route => route.name === 'deleteArticle');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+articleId, callback,this.errorCallback); 
    }

    getArticle(articleId, callback){
        const configRoute = configData.routes.find(route => route.name === 'getArticle');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+articleId, callback,this.errorCallback); 
    }

    updateArticle(arrayParams, callback){
    	const articleId = arrayParams._id;
        const configRoute = configData.routes.find(route => route.name === 'updateArticle');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url+articleId, callback,this.errorCallback); 
    }

    downloadArticles(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'downloadArticlesByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback, true); 
    }

    newArticleType(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'newArticleType');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    newArticleTypeByToken(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'newArticleTypeByToken');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getArticleTypes(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getArticleTypesByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    deleteArticleType(articleTypeId, callback){
        const configRoute = configData.routes.find(route => route.name === 'deleteArticleType');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+articleTypeId, callback,this.errorCallback); 
    }

    getArticleType(articleTypeId, callback){
        const configRoute = configData.routes.find(route => route.name === 'getArticleType');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+articleTypeId, callback,this.errorCallback); 
    }

    updateArticleType(arrayParams, callback){
    	const articleTypeId = arrayParams._id;
        const configRoute = configData.routes.find(route => route.name === 'updateArticleType');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url+articleTypeId, callback,this.errorCallback); 
    }

    downloadArticleTypes(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'downloadArticleTypesByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback, true); 
    }


    newTax(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'newTax');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    newTaxByToken(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'newTaxByToken');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getTaxes(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getTaxesByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    deleteTax(taxId, callback){
        const configRoute = configData.routes.find(route => route.name === 'deleteTax');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+taxId, callback,this.errorCallback); 
    }

    getTax(taxId, callback){
        const configRoute = configData.routes.find(route => route.name === 'getTax');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+taxId, callback,this.errorCallback); 
    }

    updateTax(arrayParams, callback){
    	const taxId = arrayParams._id;
        const configRoute = configData.routes.find(route => route.name === 'updateTax');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url+taxId, callback,this.errorCallback); 
    }

    newOperation(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'newOperation');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    newOperationByToken(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'newOperationByToken');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getOperations(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getOperationsByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    deleteOperation(taxId, callback){
        const configRoute = configData.routes.find(route => route.name === 'deleteOperation');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+taxId, callback,this.errorCallback); 
    }

    getOperation(operationId, callback){
        const configRoute = configData.routes.find(route => route.name === 'getOperation');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+operationId, callback,this.errorCallback); 
    }

    updateOperation(arrayParams, callback){
    	const operationId = arrayParams._id;
        const configRoute = configData.routes.find(route => route.name === 'updateOperation');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url+operationId, callback,this.errorCallback); 
    }

    newBill(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'newBill');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    generateReturnPayBill(id, callback){
        const configRoute = configData.routes.find(route => route.name === 'generateReturnPayBill');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+id, callback,this.errorCallback); 
    }

    newBillByToken(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'newBillByToken');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getBills(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getBillsByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    deleteBill(billId, callback){
        const configRoute = configData.routes.find(route => route.name === 'deleteBill');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+billId, callback,this.errorCallback); 
    }

    getBill(billId, callback){
        const configRoute = configData.routes.find(route => route.name === 'getBill');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+billId, callback,this.errorCallback);
    }

    getVerifactuLog(billId, callback){
        const configRoute = configData.routes.find(route => route.name === 'getVerifactuLog');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+billId+'/verifactu-log', callback, this.errorCallback);
    }

    verifactuReencolar(billId, callback){
        const configRoute = configData.routes.find(route => route.name === 'verifactuReencolar');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+billId+'/verifactu-reencolar', callback, this.errorCallback);
    }

    verifactuAnular(billId, callback){
        const configRoute = configData.routes.find(route => route.name === 'verifactuReencolar');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+billId+'/verifactu-anular', callback, this.errorCallback);
    }

    getVerifactuDashboard(callback){
        const configRoute = configData.routes.find(route => route.name === 'getVerifactuDashboard');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url, callback, this.errorCallback);
    }

    verifactuFlush(callback){
        const configRoute = configData.routes.find(route => route.name === 'verifactuFlush');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url, callback, this.errorCallback);
    }

    verifactuAdminReencolar(queueId, callback){
        const configRoute = configData.routes.find(route => route.name === 'verifactuAdminReencolar');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+queueId, callback, this.errorCallback);
    }

    getVerifactuQueueXml(queueId, callback){
        const configRoute = configData.routes.find(route => route.name === 'getVerifactuQueueXml');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+queueId+'/xml', callback, this.errorCallback);
    }

    verifactuSendRawXml(xml, callback){
        const configRoute = configData.routes.find(route => route.name === 'verifactuSendRawXml');
        this.commonPostApiCall(true, configRoute.method, [{ name: 'xml', value: xml }], configRoute.url, callback, this.errorCallback);
    }

    getVerifactuActividad(fechaDesde, fechaHasta, callback){
        const configRoute = configData.routes.find(route => route.name === 'getVerifactuActividad');
        const params = [];
        if (fechaDesde) params.push({ name: 'fechaDesde', value: fechaDesde });
        if (fechaHasta) params.push({ name: 'fechaHasta', value: fechaHasta });
        this.commonPostApiCall(true, configRoute.method, params, configRoute.url, callback, this.errorCallback);
    }

    updateBill(arrayParams, callback){
    	const billId = arrayParams._id;
        const configRoute = configData.routes.find(route => route.name === 'updateBill');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url+billId, callback,this.errorCallback); 
    }

    // Solo estado y fecha de vencimiento: editables aunque la factura ya se haya enviado a Verifactu
    updateBillEstadoVencimiento(billId, arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'updateBillEstadoVencimiento');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url+billId+'/estado-vencimiento', callback, this.errorCallback);
    }

    downloadBills(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'downloadBillsByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback, true); 
    }

    getReports(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getReportsByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    newLocation(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'newLocation');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getLocations(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getLocationsByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    deleteLocation(locationId, callback){
        const configRoute = configData.routes.find(route => route.name === 'deleteLocation');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+locationId, callback,this.errorCallback); 
    }

    getLocation(locationId, callback){
        const configRoute = configData.routes.find(route => route.name === 'getLocation');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+locationId, callback,this.errorCallback); 
    }

    updateLocation(arrayParams, callback){
    	const locationId = arrayParams._id;
        const configRoute = configData.routes.find(route => route.name === 'updateLocation');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url+locationId, callback,this.errorCallback); 
    }

    downloadReport(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'downloadReportByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback, true); 
    }

    getBookings(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getBookingsByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    downloadBookings(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'downloadBookingsByCriteria');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback, true); 
    }


    //Interfaz
    getCommonInterface(callback){
        const configRoute = configData.routes.find(route => route.name === 'getCommonInterface');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url, callback,this.errorCallback); 
    }

    getEditUserInterface(userId,callback){
        const configRoute = configData.routes.find(route => route.name === 'getEditUserInterface');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+(userId?'?userId='+userId:''), callback,this.errorCallback); 

    }

    getDashboardInterface(callback){
        const configRoute = configData.routes.find(route => route.name === 'getDashboardInterface');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url, callback,this.errorCallback); 
    }

    getSigningsInterface(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getSigningsInterface');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getEditSigningInterface(signingId,callback){
        const configRoute = configData.routes.find(route => route.name === 'getEditSigningInterface');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+(signingId?'?signingId='+signingId:''), callback,this.errorCallback); 

    }

    getClientsInterface(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getClientsInterface');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getEditClientInterface(clientId,callback){
        const configRoute = configData.routes.find(route => route.name === 'getEditClientInterface');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+(clientId?'?clientId='+clientId:''), callback,this.errorCallback); 

    }

    getEditScheduleInterface(scheduleId,callback){
        const configRoute = configData.routes.find(route => route.name === 'getEditScheduleInterface');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+(scheduleId?'?scheduleId='+scheduleId:''), callback,this.errorCallback); 

    }

    getArticlesInterface(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getArticlesInterface');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getEditArticleInterface(articleId,callback){
        const configRoute = configData.routes.find(route => route.name === 'getEditArticleInterface');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+(articleId?'?articleId='+articleId:''), callback,this.errorCallback); 
    }

    getArticleTypesInterface(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getArticleTypesInterface');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getEditArticleTypeInterface(articleTypeId,callback){
        const configRoute = configData.routes.find(route => route.name === 'getEditArticleTypeInterface');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+(articleTypeId?'?articleTypeId='+articleTypeId:''), callback,this.errorCallback);
    }

    getTaxesInterface(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getTaxesInterface');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getEditTaxInterface(taxId,callback){
        const configRoute = configData.routes.find(route => route.name === 'getEditTaxInterface');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+(taxId?'?taxId='+taxId:''), callback,this.errorCallback);
    }

    getOperationsInterface(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getOperationsInterface');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getEditOperationInterface(operationId,callback){
        const configRoute = configData.routes.find(route => route.name === 'getEditOperationInterface');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+(operationId?'?operationId='+operationId:''), callback,this.errorCallback);
    }

    getBillsInterface(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getBillsInterface');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getEditBillInterface(billId,callback){
        const configRoute = configData.routes.find(route => route.name === 'getEditBillInterface');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+(billId?'?billId='+billId:''), callback,this.errorCallback);
    }

    getLocationsInterface(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getLocationsInterface');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getEditLocationInterface(locationId,callback){
        const configRoute = configData.routes.find(route => route.name === 'getEditLocationInterface');
        this.commonPostApiCall(true, configRoute.method, [], configRoute.url+(locationId?'?locationId='+locationId:''), callback,this.errorCallback);
    }

    getReportsInterface(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getReportsInterface');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }

    getBookingsInterface(arrayParams, callback){
        const configRoute = configData.routes.find(route => route.name === 'getBookingsInterface');
        this.commonPostApiCall(true, configRoute.method, arrayParams, configRoute.url, callback,this.errorCallback); 
    }
}
